import { render, staticRenderFns } from "./MusicMobile.vue?vue&type=template&id=23732e28&scoped=true&"
import script from "./MusicMobile.vue?vue&type=script&lang=js&"
export * from "./MusicMobile.vue?vue&type=script&lang=js&"
import style0 from "./MusicMobile.vue?vue&type=style&index=0&id=23732e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23732e28",
  null
  
)

export default component.exports